import { theme } from "../../config/theme";
import styled from "styled-components";

const lightColor = "rgba(255, 255, 255, 0.7)";

const ActionButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: auto;
  button {
    /* defaults */
    border: 0;
    outline: 0;
    cursor: pointer;

    background: white;
    border-radius: 5px;
    padding: 10px 15px;
    font-weight: 600;
    color: #545454;

    &:hover {
      opacity: 0.9;
    }
  }
`;

const HeaderContainer = styled.div`
  margin-bottom: 20px;
`;

const OverlapComponent = styled.div`
  margin-top: -80px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const styles = {
  fixedWidth: {
    width: "1080px",
    margin: "auto",
    padding: "0",
    minHeight: "48px"
  },
  secondaryBar: {
    zIndex: 0,
    marginBottom: "0px"
  },
  primaryBar: {
    zIndex: 0,
    paddingTop: "30px",
    paddingBottom: "30px"
  },
  menuButton: {
    marginLeft: -theme.spacing(1)
  },
  iconButtonAvatar: {
    padding: 4
  },
  link: {
    "textDecoration": "none",
    "color": lightColor,
    "&:hover": {
      color: theme.palette.common.white
    }
  },
  logoutButton: {
    marginTop: "30px"
  },
  button: {
    borderColor: lightColor
  },
  mainTool: {
    padding: "0 50px"
  }
};

export { ActionButtons, HeaderContainer, lightColor, OverlapComponent, styles };
